import axios from "axios";
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";
export const apiClient = axios.create({
  baseURL: API_BASE,
});
// 17.10.2026: abgelaufene/ungueltige Anmeldung -> Token weg, zurueck zum Login
apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem("token")) {
      localStorage.removeItem("token");
      window.location.reload();
    }
    return Promise.reject(err);
  }
);
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers["x-token"] = token;
  return config;
});
export const api = {
  // Auth
  login: (username: string, password: string) =>
    apiClient.post("/auth/login", { username, password }),
  // Scanner
  getSignals: (mode = "intraday", minScore = 60, exchanges = "") =>
    apiClient.get("/scanner/signals", { params: { mode, min_score: minScore, exchanges } }),
  getLastScan: (mode = "intraday") =>
    apiClient.get("/scanner/last-scan", { params: { mode } }),
  getAllSymbols: (mode = "intraday", exchanges = "") =>
    apiClient.get("/scanner/all-symbols", { params: { mode, exchanges } }),
  // Watchlist
  getWatchlist: () => apiClient.get("/watchlist/"),
  addToWatchlist: (symbol: string) => apiClient.post("/watchlist/", { symbol }),
  removeFromWatchlist: (symbol: string) => apiClient.delete(`/watchlist/${symbol}`),
  // Journal
  getTrades: (status = "ALL") =>
    apiClient.get("/journal/", { params: { status } }),
  addTrade: (trade: any) => apiClient.post("/journal/", trade),
  closeTrade: (id: number, exitPrice: number) =>
    apiClient.patch(`/journal/${id}/close`, null, { params: { exit_price: exitPrice } }),
  deleteTrade: (id: number) => apiClient.delete(`/journal/${id}`),
  updateTrade: (id: number, data: any) => apiClient.patch(`/journal/${id}`, data),
  // Outcomes
  getOutcomes: (status?: string, mode?: string, symbol?: string, limit = 200) =>
    apiClient.get("/outcomes/list", { params: { status, mode, symbol, limit } }),
  getOutcomeStats: () => apiClient.get("/outcomes/stats"),
  getOutcomeStrategyStats: () => apiClient.get("/outcomes/stats-by-strategy"),
};
